// Presentation helpers for the mobile account sheet. Non-component module so the
// AccountSheet/MobileHeader component files export ONLY components (react-refresh/only-export-components), the
// `dealVocab.ts` / `sections.ts` discipline.

/** Two-letter uppercase initials for an avatar fallback (port of the MVP `initials()`). "?" when empty. */
export function initials(name: string | null | undefined): string {
  const letters = String(name ?? "")
    .trim()
    .split(/\s+/)
    .map((w) => w[0] ?? "")
    .join("")
    .toUpperCase();
  return (letters || "?").slice(0, 2);
}
